// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sendEmailLabels {
  padding-bottom: 20px;
}

.label-width {
  flex: 0 0 105px;
}

.externalComm-div-padding {
  padding-left: 17px;
  padding-right: 15px;
}

.emailTextLabel {
  padding-bottom: 215px;
}

.check-box-margin {
  margin-left: -7px;
}

.agree-to-checkbox-margin {
  margin-left: 8px;
  z-index: 90000;
}

.sendEmailButtonPadding {
  padding-bottom: 15px;
}

.info-label {
  font-weight: bold;
  padding-right: 15px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
